import React, { Component } from 'react';
import { Pagination as BootstrapPagination } from 'react-bootstrap';

class Pagination extends Component {
    render() {
        const p = this.props;
        const totalPages = Math.ceil(p.length / p.itemsPerPage);
        const range = 4;

        const renderPaginationItems = () => {
            const items = [];
            if (p.activePage > range + 1) {
                items.push(
                    <BootstrapPagination.Item
                        key={1}
                        active={p.activePage === 1}
                        onClick={() => p.onPageChange(1)}
                    >
                        1
                    </BootstrapPagination.Item>
                );
                items.push(<BootstrapPagination.Ellipsis key="start-ellipsis" />);
            }

            for (
                let i = Math.max(1, p.activePage - range);
                i <= Math.min(totalPages, p.activePage + range);
                i++
            ) {
                items.push(
                    <BootstrapPagination.Item
                        key={i}
                        active={p.activePage === i}
                        onClick={() => p.onPageChange(i)}
                    >
                        {i}
                    </BootstrapPagination.Item>
                );
            }

            if (p.activePage < totalPages - range) {
                items.push(<BootstrapPagination.Ellipsis key="end-ellipsis" />);
                items.push(
                    <BootstrapPagination.Item
                        key={totalPages}
                        active={p.activePage === totalPages}
                        onClick={() => p.onPageChange(totalPages)}
                        linkClassName={'page-item'}
                    >
                        {totalPages}
                    </BootstrapPagination.Item>
                );
            }

            return items;
        };

        return (
            <div>
                {p.length > 0 ? (
                    <div className="pagination-container mt-3">
                        <BootstrapPagination>
                            <BootstrapPagination.First
                                disabled={p.activePage === 1}
                                onClick={() => p.activePage > 1 && p.onPageChange(1)}
                            />
                            {renderPaginationItems()}
                            <BootstrapPagination.Last
                                disabled={p.activePage === totalPages}
                                onClick={() =>
                                    p.activePage < totalPages && p.onPageChange(totalPages)
                                }
                            />
                        </BootstrapPagination>
                        <p>
                            Total of {p.length} {p.isChart ? 'branches' : 'record(s)'}
                        </p>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default Pagination;
